/* eslint-disable camelcase */
import { useState } from "react";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import LibrasIcon from "../../assets/icons/libras-icon.svg"

import { Animation, AnimationData } from "../../assets/glb/animations";
import {
  ButtonExpand,
  ButtonSeeTranslation,
  ButtonTrainSignal,
  DropDownContainer,
  DropDownList,
  DropDownListContainer,
  GlossaryContainer
} from "./styles";

type GlossaryItemProps = {
  description: string;
  word: string;
  is_recognized: boolean;
  animation: Animation;
  glosa: string;
  setAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  setHeaderAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
};

export default function GlossaryItem({
  word,
  animation,
  is_recognized,
  description,
  glosa,
  setAnimation,
  setHeaderAnimation
}: GlossaryItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [style, setStyle] = useState("section-divs");
  const [transition, setTransition] = useState("fadeInDown");

  function dropDown() {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setTransition("fadeInDown");
    } else {
      setTransition("fadeOutUp");
    }
    return transition;
  }

  function changeStyle() {
    if (!isOpen) {
      setStyle("div1");
    } else {
      setStyle("section-divs");
    }
    return style;
  }

  return (
    <DropDownContainer>
      <div className="glossario-item">
         <GlossaryContainer className={style} id="transition">
          {word}
            
        </GlossaryContainer>
        <LibrasButtonMenu
              onClick={() => {
                window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));
                setAnimation([{ glosa: animation.name, animation }]);
                window.dispatchEvent(new CustomEvent("LISA_RESUME"));
              }}
            >
                <img 
                  src={LibrasIcon} 
                  alt="Ícone Libras" 
                  />
          </LibrasButtonMenu>

      </div>
       
      {isOpen && (
        <DropDownListContainer>
          <DropDownList className={transition}>
            <ButtonSeeTranslation
              onClick={() => {
                setAnimation([{ glosa: animation.name, animation }]);
              }}
            >
              <span className="material-symbols-outlined sizeIcon">
                sign_language
              </span>
              Ver tradução em libras
            </ButtonSeeTranslation>
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
}
